import { getTvObject, tv } from '@costar-ui/cosmos';

var infoCardTV = getTvObject({
  base: ['bg-base', 'border', 'min-w-60'],
  //base = common styles
  variants: {
    variant: {
      "default": ['border-neutral', 'p-6', 'gap-6'],
      elevated: ['border-neutral', 'p-6', 'gap-6', 'shadow-elevation-20'],
      dense: ['border-neutral', 'gap-4', 'p-4'],
      'dense-elevated': ['border-neutral', 'gap-4', 'p-4', 'shadow-elevation-20'],
      ghost: ['bg-transparent', 'border-transparent', 'gap-6', 'p-0'],
      'ghost-dense': ['bg-transparent', 'border-transparent', 'p-0', 'gap-4'],
      neutral: ['rounded', 'border-neutral', 'bg-neutral-subtler', 'p-2', 'gap-2'],
      'neutral-subtlest': ['border-0', 'bg-neutral-subtlest', 'p-2', 'gap-2']
    }
  }
});
var base = {
  base: tv(infoCardTV)
};
var infoCardStyles = {
  base: base
};

export { infoCardStyles, infoCardTV };
//# sourceMappingURL=info-card.styles.esm.js.map
